import { getFeaturedPlan } from "@utils/call-api/plan-call";

export const TYPES = {
  ADD_COUPON: "ADD_COUPON",
  INITIALIZE_PLAN: "INITIALIZE_PLAN",
  REMOVE_COUPON: "REMOVE_COUPON",
};

function setPlan(featuredPlan) {
  return {
    type: TYPES.INITIALIZE_PLAN,
    featuredPlan,
  };
}

export function addCoupon(coupon) {
  return { type: TYPES.ADD_COUPON, coupon };
}

export function initializePlan() {
  return async (dispatch) => {
    const featuredSubscriptionPlanRes = await getFeaturedPlan();

    return dispatch(setPlan(featuredSubscriptionPlanRes));
  };
}

export function removeCoupon() {
  return { type: TYPES.REMOVE_COUPON };
}
